// extracted by mini-css-extract-plugin
module.exports = {"textButton":"textButton_textButton__7jQea","default":"textButton_default__2Yy-4","primary":"textButton_primary__355Em","disabled":"textButton_disabled__1OhUr"};